import React from 'react';
import { useRouter } from '../../../../../@casino/useRouter';
import { useDispatch, useSelector } from 'react-redux';
import { setGetUserById } from '../../store/thunk/setGetUserById';
import TemplatePage from '../../../components/templatePage';
import { setGetReplenishmentUser } from '../../store/thunk/setGetReplenishmentUser';
import PaymentItem from '../../components/paymentItem';
import { isArray } from 'lodash';
import { setLoadingAction } from '../../../components/templatePage/store/action';
import Navigation from '../../components/navigation';

const handleLoadPagination = ({page, setPage, countPage, dispatch, id}) => {
    if (page <= countPage) {
        dispatch(setGetReplenishmentUser({
            page: page + 1,
            rowsPerPage: 50,
            id
        }));
        setPage(page + 1);
    }
}

const handleLoading = (dispatch) => {
    dispatch(setLoadingAction(true))
}

const Deposit = () => {
    const router = useRouter();
    const dispatch = useDispatch();
  
    const {id} = router.query;

    const [page, setPage] = React.useState(1);
    const [isShowNavigation, setIsShowNavigation] = React.useState(false);

    React.useEffect(() => {
        dispatch(setGetUserById(id))
    }, [id])

    const view = useSelector(state => state.usersMobile.view);

    React.useEffect(() => {
        if (view?.login) {
            dispatch(setGetReplenishmentUser({
                id: view?.login,
                page: 1,
                rowsPerPage: 50
            }));
        }
        // eslint-disable-next-line
    }, [view?.login])

   
    const list = useSelector(state => state.usersMobile.user_replenishment);
    if (view?.login) {
        return (
            <TemplatePage
                title={`Депозиты (${view.login ? view.login : ''})`}
                pagination={page < list.countPage && list.data.length}
                handleLoadPagination={() => handleLoadPagination({
                    page,
                    setPage,
                    countPage: list.countPage,
                    dispatch,
                    id: view.login
                })}
                handleLoading={() => handleLoading(dispatch)}
            >
                <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', columnGap: 10}}>
                    <span 
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%',
                            border: '1px solid #ffce01',
                            cursor: 'pointer',
                            outline: 'none',
                            padding: '5px 0',
                            background: '#ffce01',
                            borderRadius: '12px',
                            color: '#24263e',
                            fontSize: 14,
                            fontWeight: 700,
                        }}
                        onClick={() => {
                            setIsShowNavigation(true)
                        }}
                    >Дополнительно</span>
                </div>
                {
                    list.data.map((item) => <PaymentItem item={item} array={isArray(item)}/>)
                }
                <Navigation isShowNavigation={isShowNavigation} setIsShowNavigation={setIsShowNavigation} id={id}  profile={view}/>
            </TemplatePage>
        )
    } else {
        return <>loading</>
    }
}

export default Deposit;